import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { memo, useEffect, useState } from "react";

interface CDialogProps {
  open?: boolean;
  title?: string;
  type?: "error" | "warning" | "success";
  iconSize?: "small" | "medium" | "large";
  iconButton?: JSX.Element;
  onClose?: () => void;
  onSave?: () => void;
  children: JSX.Element;
}

export const CDialog = memo(
  ({
    open,
    title,
    type,
    iconButton,
    onClose,
    onSave,
    iconSize,
    children,
  }: CDialogProps) => {
    const [openState, setOpenState] = useState(false);

    useEffect(() => {
      if (open) {
        setOpenState(open);
      }
    }, [open]);

    const handleClose = () => {
      if (onClose) {
        onClose();
      }
      setOpenState(false);
    };

    return (
      <>
        {iconButton && (
          <IconButton
            size={iconSize ? iconSize : "medium"}
            onClick={() => setOpenState(true)}
          >
            {iconButton}
          </IconButton>
        )}
        <Dialog onClose={handleClose} open={openState}>
          <DialogTitle>{title ?? ""}</DialogTitle>
          <DialogContent>{children}</DialogContent>
          <DialogActions>
            <Button onClick={handleClose} sx={{ color: "rgba(0, 0, 0, 0.6)" }}>
              Cancelar
            </Button>
            <Button
              onClick={() => {
                if (onSave) {
                  onSave();
                }
                setOpenState(false);
              }}
              autoFocus
              color={type && type}
            >
              Aceitar
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
);
